<template>
  <div class="bundle-addon">
    <!-- Title Section -->
    <div class="text-header text-success font-bold mb-2">
      {{ title }}
    </div>

    <!-- Card Section -->
    <div class="card">
      <div class="card-body flex justify-between items-center">
        <!-- Plan Details -->
        <div>
          <span class="text-gray-600 font-semibold" v-if="planName">{{
            planName
          }}</span>
          <div v-html="detailsHtml"></div>

          <div v-if="!detailsHtml">
            <p>{{ planDetails.duration }}</p>
            <p>{{ planDetails.minutes }} National Minutes</p>
            <p>{{ planDetails.sms }} SMS</p>
            <a href="#" class="text-success text-sm underline">{{
              termsLinkText
            }}</a>
          </div>
          <!-- promo Details -->
          <div v-if="promoDetails && Object.keys(promoDetails).length">
            <p class="text-gray-600 font-semibold">Promo Details:</p>
            <p>
              Promocode:
              {{
                promoDetails &&
                promoDetails.Promotion_Name &&
                promoDetails.Promotion_Name.promoCode
              }}
            </p>
            <div
              v-html="
                promoDetails &&
                promoDetails.Feature_list &&
                promoDetails.Feature_list.text
              "
            ></div>
          </div>
        </div>

        <!-- Pricing & Button -->
        <div class="text-right">
          <p class="text-lg font-bold">
            {{ currencySymbol }} {{ discountedPrice.toFixed(2) }}
          </p>
          <p
            class="text-gray-400 line-through"
            v-if="originalPrice && discountRate > 0"
          >
            {{ currencySymbol }}{{ originalPrice.toFixed(2) }}
          </p>
          <button
            class="btn mt-3"
            :class="buttonType === 'change' ? 'btn-change' : 'btn-remove'"
            @click="handleAction"
          >
            {{ buttonLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "basket",
  props: {
    title: {
      type: String,
      required: true,
    },
    planDetails: {
      type: Object,
      required: false,
      default: () => ({
        duration: "1 Month 1 GB",
        minutes: 150,
        sms: 100,
      }),
    },
    planName: { type: String },
    detailsHtml: {
      type: String,
      default: "",
    },
    termsLinkText: {
      type: String,
      default: "View T & C",
    },
    discountedPrice: {
      type: Number,
      required: true,
    },
    discountRate: {
      type: Number,
      required: true,
    },
    currencySymbol: {
      type: String,
      required: true,
      default: "$",
    },
    originalPrice: {
      type: Number,
      default: null,
    },
    promoDetails: {
      type: Object,
      default: () => {},
    },
    buttonType: {
      type: String,
      default: "change", // Options: 'change' or 'remove'
    },
    buttonLabel: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleAction() {
      this.$emit("action", this.title);
    },
  },
};
</script>

<style scoped>
.bundle-addon {
  margin-bottom: 1rem;
}

.text-header {
  font-size: 1rem;
}

.card {
  background: #e7fae8;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  border: 1px solid #00000026;
}

.card-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: bold;
  cursor: pointer;
}

.btn-change {
  background: #ecec96;
  color: #000;
}

.btn-remove {
  background: #fdb9bb;

  color: #721c24;
}

.line-through {
  text-decoration: line-through;
}
</style>
